import StyledSubmitButton from '@/atoms/Buttons/Submit/styles';
import StyledIcon from '@/atoms/Icon/styles';
import Modal from '@/organisms/Modal/Modal';
import breakpoints from '@/theme/constants/breakpoints';
import colors from '@/theme/constants/colors';
import pxToRem from '@/theme/helpers/pxToRem';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import styled from 'styled-components';

export const StyledContactArtistModal = styled(Modal)`
  @media only screen and ${breakpoints.device.s} {
    min-width: ${sizePx(250)};
  }

  h5 {
    ${typography.Title}
    margin-top: -${sizePx(8)};
  }

  fieldset {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${sizePx(8)};
    height: 100%;
  }

  form {
    flex-grow: 1;
  }

  ${StyledSubmitButton} {
    margin-top: auto;
  }
`;

export const StyledAttachment = styled.div`
  padding: ${sizePx(8)};
  background: ${colors.grey};
  border-radius: ${sizePx(2)};

  label {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${sizePx(8)};
    ${typography.Body2}

    ${StyledIcon} {
      background: ${colors.darkGreen};
      color: ${colors.white};
      padding: ${sizePx(1)};
    }
  }

  input {
    border: none;
    border-radius: 4px;
    background: ${colors.grey25};
    color: ${colors.darkBlue100};
    padding: ${pxToRem(5)} ${pxToRem(10)};
    ${typography.Body2}
  }
`;

export const StyledCustomUploader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledFiles = styled.div`
  padding: ${pxToRem(5)} ${pxToRem(10)};
  ${typography.Body2}

  & > p {
  color: ${colors.darkBlue75};
`;

export const StyledConfirmationMsg = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizePx(8)};
  margin-top: -${sizePx(5)};

  p:first-of-type {
    ${typography.Art}
  }
`;
